import React from "react";
import styled from "styled-components";

//
import Learn from "./sections/Learn";
import Course from "./sections/Course";
import Review from "./sections/Review";
import Faq from "./sections/Faq";

export default function Home() {
  return (
    <StyledHome>
      <Learn />
      <Course />
      <Review />
      <Faq />
    </StyledHome>
  );
}

const StyledHome = styled.main`
  .section_title {
    font-size: 2rem;
    padding-bottom: 20px;
    font-weight: 500;
    line-height: 1.2;
    border-bottom: 1px solid #c0c3c7;
  }

  @media screen and (max-width: 991px) {
    .section_title {
      font-size: calc(1.325rem + 0.9vw);
    }
  }
`;
